import { LocationHoursOfOperation } from 'fhir/r4';
import { DaysOfWeek, FinalDataReturn, PractitionerOrOrganization } from '../../interfaces/interfaces';

type Sorter = (x: PractitionerOrOrganization, y: PractitionerOrOrganization) => 0 | 1 | -1;

const sorter: Sorter = (a, b) => {
  if ((a?.name ?? {}) > (b?.name ?? {})) {
    return 1;
  }
  if ((a?.name ?? {}) < (b?.name ?? {})) {
    return -1;
  }
  return 0;
};

export const sortByDistanceFn = (practitionersArr: FinalDataReturn) => {
  const isNotZero = (el: [string, PractitionerOrOrganization]) => el?.[1]?.distanceFromOrigin > 0;
  const isZero = (el: [string, PractitionerOrOrganization]) => el?.[1]?.distanceFromOrigin === 0;

  const placeZerosAtEnd = (arr: [string, PractitionerOrOrganization][]) => arr.filter(isNotZero).concat(arr.filter(isZero));
  const sortByDistanceWithZeroInTheBeginning = [...practitionersArr.data.entries()].sort(
    (a, b) => a?.[1]?.distanceFromOrigin - b?.[1]?.distanceFromOrigin
  );

  const sortByDistance = new Map(placeZerosAtEnd(sortByDistanceWithZeroInTheBeginning));
  return { ...practitionersArr, data: sortByDistance };
};

export const cachingDecorator = (func: (x: FinalDataReturn) => FinalDataReturn) => {
  const cache = new WeakMap();

  return (obj: FinalDataReturn) => {
    if (!cache.has(obj.data)) {
      const result = func(obj);
      cache.set(obj.data, result);
    }
    return cache.get(obj.data);
  };
};

export const dataDistanceFn = cachingDecorator(sortByDistanceFn);

// export const cachingDecoratorPostalCode = (func: (x: string) => Promise<string>) => {
//   const cache = new Map();
//   return (postalCode: string) => {
//     if (!cache.has(postalCode)) {
//       const result = func(postalCode);
//       cache.set(postalCode, result);
//     }
//     return cache.get(postalCode);
//   };
// };

export const sortDaysOfWeek = (sortArray: LocationHoursOfOperation[] | undefined) => {
  const weekDaysEntry: Map<keyof DaysOfWeek, fhir4.LocationHoursOfOperation> = new Map();
  if (sortArray != null) {
    sortArray.forEach((item) => {
      if (item.daysOfWeek != null) {
        item.daysOfWeek.forEach((i) => {
          if (weekDaysEntry.has(i)) return;
          weekDaysEntry.set(i, item);
        });
      }
    });
  }
  return weekDaysEntry;
};

export default sorter;
